import React, { useState } from "react";
import { 

  Box, Tab, Tabs, Grid } 
from "@mui/material";
//import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import "../home/home.style.css";
//import TabsMedication from "./tabs_medication";
//import AcUnitIcon from "@mui/icons-material/AcUnit";
import Allergies from "./allergies";
import SearchBox from "../shared/searchbox";
import HandList from "./hand_list";
import { dashboardText, icon34, mainGrid, paddingbox, pcolor, rcolor } from "../../style2";


// const useStyles = makeStyles((theme) => ({
//   paddingbox: {
//     paddingLeft: 170,
//     paddingTop: 50,
//     paddingRight: 50,
//     [theme.breakpoints.down("md")]: {
//       paddingLeft: 100,
//       paddingTop: 35,
//       paddingRight: 30,
//     },
//   },
//   DashboardText: {
//     fontFamily: "Lato",
//     fontStyle: "normal",
//     fontWeight: "bold",
//     fontSize: 20,
//     color: "#001244",
//   },
//   buttonReverseColors: {
//     width: 140,
//     height: 40,
//     background: "#FFFFFF",
//     border: "1px solid #FF767E",
//     boxSizing: "border-box",
//     borderRadius: 9,
//     textTransform: "unset",
//     color: "#FF767E",
//     "&:hover": {
//       color: "#FFFFFF",
//       background: "#FF767E",
//     },
//   },
//   mainGrid: {
//     border: "1px solid #fff",
//     backgroundColor: "#F6F6F6",
//     borderRadius: "9px",
//     padding:"20px"
//   },
//   buttonviewmore: {
//     fontFamily: "Lato",
//     fontStyle: "normal",
//     fontWeight: "normal",
//     fontSize: 14,
//     color: "#FF767E",
//     textTransform: "unset",
//     "&:hover": {
//       background: "#FFFFFF",
//     },
//   },
//   searchBox: {
//     border: "0.5px solid #FF767E",
//     borderRadius: 7,
//     margin: "auto",
//     height: 40,
//     boxShadow: "none",
//   },
// }));

function Medications_Allergies(props) {
  //const classes = useStyles();

  const [searchMed, setSearchMed] = useState("");
  const [searchMedAllgeries, setSearchMedAllgeries] = useState("");
  const [searchOtherAllgeries, setSearchOtherAllgeries] = useState("");
  const [allergytabvalue, setAllergyTabValue] = React.useState(0);
  
  const handleAllergyTabChange = (event, newValue) => {
    //console.log("AllergyTabValue: " + newValue);
    setAllergyTabValue(newValue);
  };

  return (
    <>
      <Box sx={paddingbox} id={props.id}>
        <Grid container spacing={2}>
          <Grid item sm={12} md={6}  >
            <Box display="flex" alignItems="center" sx={dashboardText}>
              <Box component="img" src="assets/medicine.png" sx={icon34}></Box>
              <Box mr={1}/>
              Medication
            </Box>
            <Box sx={{...mainGrid, marginTop:"20px"}}>
              <SearchBox onChange={(newValue) => setSearchMed(newValue)} />
              {/* <TabsMedication searchValue={searchMed} /> */}
              <HandList searchValue={searchMed} />
            </Box>
          </Grid>
    
          <Grid item sm={12} md={6}  >
            <Box display="flex" alignItems="center" sx={dashboardText} >
              <Box component="img" src="assets/allergy.png" sx={icon34}></Box>
              <Box mr={1}/>
              Allergies
            </Box>
            <Box sx={{...mainGrid, marginTop:"20px"}}>
              <Tabs value={allergytabvalue} onChange={handleAllergyTabChange} style={{ borderRight: 1, borderColor: "divider", width:"100%" }} TabIndicatorProps={{ style: { backgroundColor: rcolor } }} >
                <Tab label="Medication" style={{minWidth:"250px", width:"50%", color: pcolor, fontWeight:"bold", fontSize:"16px", textTransform:"Capitalize"}}  />
                <Tab label="Others (Food)" style={{minWidth:"250px", width:"50%", color: pcolor, fontWeight:"bold", fontSize:"16px", textTransform:"Capitalize"}}  />
                </Tabs>
            <div hidden={allergytabvalue == 0 ? false : true}>
            {/* <SearchBox onChange={(newValue) => setSearchMedAllgeries(newValue)} /> */}
              <Allergies searchValue={searchMedAllgeries} type="Medication" />
            </div>
            <div hidden={allergytabvalue == 1 ? false : true}>
             {/* <SearchBox onChange={(newValue) => setSearchOtherAllgeries(newValue)} /> */}
              <Allergies searchValue={searchOtherAllgeries} type="OthersFood" /> 
            </div>
              
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default Medications_Allergies;
